// extracted by mini-css-extract-plugin
export default {"expand":"subItem__expand-bmoRX","collapse":"subItem__collapse-e5xOH","active":"subItem__active-fiRGM"};